// src/components/login/Login.js
import React, { useState, useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import CustomInput from '../inputs/CustomInput';
import CustomSecureInput from '../inputs/CustomSecureInput';
import { ReactComponent as UserIcon } from '../../assets/icons/person.svg';
import { ReactComponent as LockIcon } from '../../assets/icons/lock.svg';
import { ReactComponent as EyeIcon } from '../../assets/icons/eye.svg';
import logo from '../../assets/images/gameup_dark.png';
import {
    Box,
    Typography,
    Button,
    Link,
    useMediaQuery,
    useTheme,
} from '@mui/material';

const Login = () => {
    const [credentials, setCredentials] = useState({
        email: '',
        password: '',
    });
    const { login } = useContext(AuthContext);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const handleInputChange = (field, value) => {
        setCredentials((prevCredentials) => ({
            ...prevCredentials,
            [field]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        login(credentials);
    };

    return (
        <Box
            sx={{
                height: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#FFFFFF',
                padding: 2,
            }}
        >
            <Box
                sx={{
                    width: isMobile ? '90%' : '400px',
                    padding: isMobile ? 3 : 4,
                    borderRadius: 2,
                    textAlign: 'center',
                    backgroundColor: '#FFFFFF',
                    marginBottom: isMobile ? '103px' : '40px',
                }}
            >
                <Box
                    component="img"
                    src={logo}
                    alt="Logo"
                    sx={{
                        width: isMobile ? 195 : 227,
                        marginBottom: isMobile ? '32px' : '40px',
                    }}
                />
                <Typography
                    sx={{
                        fontFamily: 'Poppins',
                        fontSize: '24px',
                        fontWeight: 500,
                        color: '#292929',
                        marginBottom: 3,
                    }}
                >
                    Acessar plataforma
                </Typography>

                <CustomInput
                    label="E-mail"
                    placeholder="seu e-mail da GameUP."
                    icon={UserIcon}
                    onChange={(value) => handleInputChange('email', value)}
                    sx={{ marginBottom: '24px' }}
                />

                <CustomSecureInput
                    label="Senha"
                    placeholder="sua senha de acesso."
                    icon={LockIcon}
                    eyeIcon={EyeIcon}
                    onChange={(value) => handleInputChange('password', value)}
                />

                <Button
                    fullWidth
                    variant="contained"
                    sx={{
                        mt: isMobile ? '39px' : '40px',
                        mb: '24px',
                        fontSize: '16px',
                        fontWeight: '500',
                        minHeight: '40px',
                        backgroundColor: '#1F83FF',
                        '&:hover': {
                            backgroundColor: '#1565C0',
                        },
                    }}
                    onClick={handleSubmit}
                >
                    Entrar
                </Button>

                <Link
                    href="/forgot-password"
                    sx={{
                        display: 'block',
                        textAlign: 'center',
                        mt: 2,
                        color: '#1F83FF',
                        fontSize: '14px',
                        fontWeight: '400',
                        '&:hover': { textDecoration: 'underline' },
                    }}
                >
                    Esqueci minha senha
                </Link>
            </Box>
        </Box>
    );
};

export default Login;
